import React, { useEffect, useState, useRef } from "react";
import { Grid, Box, Button, Table, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow, Paper, IconButton, TableHead } from "@material-ui/core";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
// styles
import useStyles from "../../../themes/makeStyles";
import clsx from "clsx";
import moment from "moment";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import PropTypes from "prop-types";
import { default as Apiservices } from '../../../common';
import {
    useForm,
    Controller,
    FormContext,
    useFormContext,
    useFieldArray,
} from "react-hook-form";
import DateRangePicker from "../../../components/DateRangePicker";
import Tooltip from '@material-ui/core/Tooltip';


const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(0),
    },
}));

function TablePaginationActions(props) {




    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event) => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };



    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                ) : (
                    <KeyboardArrowLeft />
                )}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                ) : (
                    <KeyboardArrowRight />
                )}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles({
    table: {
        minWidth: "100%",
        whiteSpace: "nowrap",
        td: {

        }
    },
    toobarBgColor: {
        "& .MuiToolbar-regular": {
            background: "#fff",
        },
    },
    container: {
        maxHeight: "60vh",
        minHeight: "100px",
        overflowY: "hidden",
        "&:hover": {
            overflowY: "auto",
            "&::-webkit-scrollbar": {
                width: "4px",
            },

            /* Track */

            "&::-webkit-scrollbar-track": {
                background: "#fff",
            },

            /* Handle */

            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#d4d8da",
                borderRadius: "20px",
            },

            /* Handle on hover */

            "&::-webkit-scrollbar-thumb:hover": {
                background: "",
            },
        },
    },
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

export default function IdelWeightReport(props) {
    var classesTwo = useStyles();
    const classes = useStyles2();
    const [page, setPage] = React.useState(0);
    const [array, setArray] = React.useState([
        { invoicedate: "No Data", count: "No Data" },
    ]);
    const [loading, setLoading] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [endDate, setEndDate] = React.useState(null);
    const [resetvalues, setResetvalues] = React.useState(true);
    const [sftorrStartDate, setSftorrStartDate] = useState();
    const [sftorrEndDate, setSftorrEndDate] = useState();
    const [disableSftoButton, setDisableSftoButton] = useState(true);


    var tableData = [{
        destination: "No Data",
        ir_load_name: "No Data",
        ir_rake_id: "No Data",
        rr_actual_weight: "No Data",
        rr_amount: "No Data",
        rr_chargeable_weight: "No Data",
        rr_date: "No Data",
        rr_no: "No Data",
        rr_punitive: "No Data"
    }]

    const fetchData = async () => {
        let fromDate, endDate;
        if (moment(new Date()).format("YYYY-MM-DD") >= `${new Date().getFullYear()}-04-01`) {
            fromDate = `${new Date().getFullYear()}-04-01`
            endDate = `${new Date().getFullYear() + 1}-03-31`
        } else {
            fromDate = `${new Date().getFullYear() - 1}-04-01`
            endDate = `${new Date().getFullYear()}-03-31`
        }
        let queryparams = {
            loading_start_date: fromDate,
            loading_end_date: endDate
        }
        const response = await Apiservices.idelWeightReports(queryparams);
        console.log('response of the ideal weight report: ' + response.Records[0].rakes_list);
        if (response && response.Records.length > 0) {
            setArray(response.Records && response.Records.length && response.Records[0].rakes_list
                && response.Records[0].rakes_list.length > 0 ? response.Records[0].rakes_list : tableData);
        } else {
            setArray(tableData);
            console.log("Server not working")
        }
    }



    const methods = useForm({
        mode: "onChange",
        validateCriteriaMode: "all",
        // defaultValues: getHeaderInfoDefaultData(modeOfDispatch),
    });

    const {
        register,
        control,
        errors,
        handleSubmit,
        setValue,
        reset,
        getValues,
    } = methods;

    useEffect(() => {
        const response = fetchData()
    }, []);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getSplInstructions = (instructions) => {
        let value = '';
        let spitOfInstructions = instructions.split(" ");
        for (let i = 0; spitOfInstructions.length; i++) {
            if (spitOfInstructions[i] === 'Load' || spitOfInstructions[i] === 'LOAD' || spitOfInstructions[i] === 'load') {
                value = value + ' ' + spitOfInstructions[i];
                return value;
            } else {
                value = value + ' ' + spitOfInstructions[i];
            }
        }
        return value;
    }

    const getRakeIdFromName = (rakeId) => {
        let splitRakeId = rakeId.split("/");
        return splitRakeId[0];
    }


    const handleSearchCriteriaSubmit = async (submitteddata) => {
        let queryparams = {};
        let loading_start_end_dates = submitteddata.rr_start_end_date
            ? submitteddata.rr_start_end_date.split("To")
            : null;
        queryparams.loading_start_date = loading_start_end_dates
            ? moment(loading_start_end_dates[0].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
            : null;
        queryparams.loading_end_date = loading_start_end_dates
            ? moment(loading_start_end_dates[1].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
            : null;
        setLoading(true);
        let response = await Apiservices.idelWeightReports(queryparams);
        if (response && response.Records.length > 0) {
            setArray(response.Records && response.Records.length && response.Records[0].rakes_list
                && response.Records[0].rakes_list.length > 0 ? response.Records[0].rakes_list : tableData);
            setDisableSftoButton(false);
        } else {
            setArray(tableData);
            console.log("Server not working")
        }
        setLoading(false);
    };

    const resetForm = async () => {
        setResetvalues(!resetvalues);
        setDisableSftoButton(true);
        let startDate, endDate;
        if (moment(new Date()).format("YYYY-MM-DD") >= `${new Date().getFullYear()}-04-01`) {
            startDate = `${new Date().getFullYear()}-04-01`
            endDate = `${new Date().getFullYear() + 1}-03-31`
        } else {
            startDate = `${new Date().getFullYear() - 1}-04-01`
            endDate = `${new Date().getFullYear()}-03-31`
        }
        let obj = {
            loading_start_date: startDate,
            loading_end_date: endDate
        }
        setLoading(true);
        let response = await Apiservices.idelWeightReports(obj);
        setArray(response.Records && response.Records[0].rakes_list
            && response.Records[0].rakes_list.length > 0 ? response.Records[0].rakes_list : tableData);
        setLoading(false);
    };

    const generateReport = async () => {
        let startDate, endDate;
        if (moment(new Date()).format("YYYY-MM-DD") >= `${new Date().getFullYear()}-04-01`) {
            startDate = `${new Date().getFullYear()}-04-01`
            endDate = `${new Date().getFullYear() + 1}-03-31`
        } else {
            startDate = `${new Date().getFullYear() - 1}-04-01`
            endDate = `${new Date().getFullYear()}-03-31`
        }
        if (sftorrStartDate) {
            startDate = sftorrStartDate;
        } else {
            startDate = startDate;
        }
        if (sftorrEndDate) {
            endDate = sftorrEndDate;
        } else {
            endDate = new Date(moment(new Date).format("YYYY-MM-DD"))
        }
        let data = {
            loading_start_date: startDate,
            loading_end_date: endDate
        }
        Apiservices.downloadIdelWeightReports(data);
    };

    return (
        <>
            <div>
                <Box py={3}>
                    <Grid container spacing={2} justify="space-between" alignItems="center">
                        <Grid item>
                            <h2 className={classesTwo.mainHeading}>{"SFTO - IDLE Weight Report"}</h2>
                        </Grid>
                    </Grid>
                </Box>



                <Box py={1}>
                    <form
                        onSubmit={handleSubmit(handleSearchCriteriaSubmit)}
                        id="list-job"
                        key={resetvalues}
                    >
                        <Grid container spacing={2} justify='space-between' alignItems='center'>

                            <Grid item >
                                <Controller
                                    as={<DateRangePicker />}
                                    name="rr_start_end_date"
                                    control={control}
                                    rules={{ required: false }}
                                    required={false}
                                    disabled={false}
                                    onChange={([value]) => {
                                        let queryparams = {};
                                        let loading_start_end_dates = value.split("To");
                                        setSftorrStartDate(loading_start_end_dates
                                            ? moment(loading_start_end_dates[0].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
                                            : null);
                                        setSftorrEndDate(
                                            loading_start_end_dates
                                                ? moment(loading_start_end_dates[1].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
                                                : null
                                        );
                                        return value;
                                    }}
                                    id="rr_start_end_date"
                                    label="Loading Date Range"
                                />
                            </Grid>
                            <Grid item>
                                <Grid container spacing={2} justify='flex-end'>
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className={clsx(
                                                classes.subTextButton
                                            )}
                                            type="submit"
                                        >
                                            Search
                                        </Button>
                                    </Grid>

                                    <Grid item>

                                        <Button
                                            variant="outlined"
                                            className={clsx(classes.subTextButton)}
                                            onClick={resetForm}
                                        >
                                            Clear
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className={clsx(
                                                classes.subTextButton
                                            )}
                                            type="button"
                                            onClick={generateReport}
                                            startIcon={<CloudDownloadIcon />}
                                            disabled={disableSftoButton}
                                        >
                                            Export to Excel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </Box>

                <div>
                    <Box py={1}>
                        <TableContainer component={Paper} className={clsx('freezeTable', classes.container)}>
                            <Table
                                // className={clsx('freezeTable')}
                                aria-label="simple table"
                                stickyHeader
                            >
                                {loading ? (
                                    <></>
                                ) : (
                                    <>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="center" >
                                                    <b>SR.NO</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center" style={{ minWidth: 100 }}>
                                                    <b>RAKE NAME</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center" style={{ minWidth: 120 }}>
                                                    <b>RAKE TYPE</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center" style={{ minWidth: 60 }}>
                                                    <b>DESTINATION</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center" style={{ minWidth: 60 }}>
                                                    <b>JOB ID</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <b>LOADING DATE</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <b>PCC</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <b>CHARGEABLE WEIGHT (MT)</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <b>ACTUAL WEIGHT (MT)</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <b>% IDLE WEIGHT</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <b>AVG.COIL SIZE (MT)</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <b>Ex-PLANT</b>
                                                </StyledTableCell>
                                                {/* <Tooltip title=" DISTRIBUTION OF WAGONS WITH DIFFERENT CUSTOMERS"> */}
                                                {/* <StyledTableCell align="center">

                                                   <b> DISTRIBUTION OF WAGONS WITH DIFFERENT CUSTOMERS</b>
                                                </StyledTableCell> */}
                                                {/* </Tooltip> */}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? array.slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                : array
                                            ).map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell align="center" style={{ minWidth: 190, maxWidth: 190 }}>
                                                        <div>
                                                            <b>{index + 1}</b>
                                                        </div>
                                                    </TableCell>
                                                   
                                                    <TableCell align="center">
                                                        <div>
                                                            {
                                                                row.rake_name ?
                                                                    <b>{row.rake_name}</b> :
                                                                    <b>-</b>
                                                            }
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <div>
                                                            {
                                                                row.rake_type ?
                                                                    <b>{row.rake_type}</b> :
                                                                    <b>-</b>
                                                            }
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <div>
                                                            {
                                                                row.destination ?
                                                                    <b>{row.destination}</b> :
                                                                    <b>-</b>
                                                            }
                                                        </div>
                                                    </TableCell>
                                                     <TableCell align="center">
                                                        <div>
                                                            {
                                                                row.rake_name ?
                                                                    <b>{row.job_id}</b> :
                                                                    <b>-</b>
                                                            }
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <div>
                                                            {
                                                                row.loading_date ?
                                                                    <b>{moment(row.loading_date).format("DD-MM-YYYY")}</b> :
                                                                    <b>-</b>
                                                            }
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <div>
                                                            {
                                                                row.chargeable_weight ?
                                                                    <b>{row.chargeable_weight}</b> :
                                                                    <b>-</b>
                                                            }
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <div>
                                                            {
                                                                row.rr_chargeable_weight ?
                                                                    <b>{row.rr_chargeable_weight}</b> :
                                                                    <b>-</b>
                                                            }
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <div>
                                                            {
                                                                row.rr_actual_weight ?
                                                                    <b>{row.rr_actual_weight}</b> :
                                                                    <b>-</b>
                                                            }
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <div>
                                                            {
                                                                row.idle_weight ?
                                                                    <b>{(row.idle_weight).toFixed(2)}</b> :
                                                                    <b>-</b>
                                                            }
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <div>
                                                            <b>-</b>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <div>
                                                            {
                                                                row.origin ?
                                                                    <b>{row.origin}</b> :
                                                                    <b>-</b>
                                                            }
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>

                                        <TableFooter>
                                            <TableRow></TableRow>
                                        </TableFooter>
                                    </>
                                )}
                            </Table>
                        </TableContainer>
                        <TableContainer>
                            <TablePagination
                                className={classes.toobarBgColor}
                                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                                component="div"
                                count={array && array.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: { "aria-label": "rows per page" },
                                    native: true,
                                }}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableContainer>
                    </Box>
                </div >
            </div>
        </>
    );
}